module.exports = __webpack_public_path__ + "img/1440.e62f4e23.jpg";